import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

export function listClientCourses(clientViewId, params = {}) {
  return clientPortalRequest(`/views/${clientViewId}/courses${buildClientQuery(params)}`);
}

export function getClientCommunityOptions(clientViewId) {
  return clientPortalRequest(`/views/${clientViewId}/courses/community-options`);
}

export function getClientCourse(clientViewId, courseId) {
  return clientPortalRequest(`/views/${clientViewId}/courses/${courseId}`);
}

export function createClientCourse(clientViewId, body) {
  return clientPortalRequest(`/views/${clientViewId}/courses`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateClientCourse(clientViewId, courseId, body) {
  return clientPortalRequest(`/views/${clientViewId}/courses/${courseId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function updateClientCourseStatus(clientViewId, courseId, displayStatus) {
  return clientPortalRequest(`/views/${clientViewId}/courses/${courseId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ displayStatus }),
  });
}

export function archiveClientCourse(clientViewId, courseId) {
  return clientPortalRequest(`/views/${clientViewId}/courses/${courseId}`, {
    method: "DELETE",
  });
}
